import { useTranslation } from "react-i18next";
import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import headerImg from "../../assets/images/background/13.jpg";
import AboutMidContent from "../../components/about/AboutMidContent";
import Footer from "../../components/layout/Footer";
import img from "../../assets/images/about/vision.jpg";

function Vision() {
  const { t } = useTranslation();

  return (
    <>
      <MainHeader />
      <PageHeader image={headerImg} title={t("Vision")} />
      <AboutMidContent
        subTitle={t("Our Vision")}
        title={t("vision-info")}
        text1={t("vision-info")}
        image={img}
      />
      <Footer />
    </>
  );
}

export default Vision;
